/* eslint-disable react/display-name */
import React, { memo, useCallback } from 'react';
import styled from 'styled-components';
import { reduxConnect } from '../../common';
import { lifeSubNavMenuAction } from '../../common/actions/lifePageSubNavigationActions';
import { largeMediaQuery } from '../../common/utilities/sizeHelpers';

interface LifePageSubNavLinkItemProps {
    isActive: boolean;
    linkName: string;
    linkUrl: string;
    enableLifePollenPageOnWeb2: boolean;
    enableLifeColdFluPageOnWeb2: boolean
    lifeSubNavMenuAction(open: boolean): void;
}

const mapStoreStateToProps = (storeState: any) => {
    return {};
};

const mapDispatchToProps = {
    lifeSubNavMenuAction
};

export const LifePageSubNavLinkItem = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(memo(({ 
    linkName,
    linkUrl,
    isActive,
    enableLifePollenPageOnWeb2,
    enableLifeColdFluPageOnWeb2,
    lifeSubNavMenuAction
}: LifePageSubNavLinkItemProps) => {

    const onClose = useCallback(() => {
        lifeSubNavMenuAction(false);
    }, []);

    if (enableLifePollenPageOnWeb2 || enableLifeColdFluPageOnWeb2) {
        return (
            <Container>
                <SubNavLink href={linkUrl} target='_self' isActive={isActive} onClick={onClose}>
                    {linkName}
                </SubNavLink>
            </Container>
        );
    }
    return (
        <Container>
            <SubNavLink href={linkUrl} isActive={isActive} onClick={onClose}>
                {linkName}
            </SubNavLink>
        </Container>
    );
}));

LifePageSubNavLinkItem.displayName = 'LifePageSubNavLinkItem';

const Container = styled.div`
    display: flex;
    width: 100%;
    height: 49px;
    border-bottom: 1px solid #a9a9a9;
    justify-content: center;
    align-items: center;
    @media ${largeMediaQuery} {
        height: 40px;
        border-bottom: none;
        justify-content: flex-start;
        align-items: initial;
    }
`;

interface SubNavLinkProps {
    isActive: boolean;
}

const SubNavLink = styled.a<SubNavLinkProps>`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 13px 20px;
    font-size: 14pt;
    width: 100%;
    text-decoration: none;
    color: #000000;
    height: 49px;
    transition: color .15s ease-in-out, border-bottom-color .15s ease-in-out;
    font-weight: ${({ isActive }) => isActive ? '600' : '400'};
    text-transform: uppercase;

    @media ${largeMediaQuery} {
        text-transform: initial;
        color: #ffffff;
        font-size: 16px;
        width: auto;
        padding: 10px 0px 4px 0px;
        border-bottom: ${({ isActive }) => isActive && '3px solid rgba(255, 255, 255, 0.9)'};
    
        &:hover {
            border-bottom: 3px solid rgba(255, 255, 255, 0.7);
        }
    }
`;